import { ButtonBase, SxProps, Typography } from '@mui/material';
import { CardLinkFrameSx, CardLinkNameSx } from '@/components/content/HelpCenter/styles/cardLink';
import { combineSX } from '@/utils/combineSX';

export const CardLink = ({
	name,
	icon,
	isActive,
	sx,
	onClick,
}: {
	name: string;
	icon: React.ReactNode;
	isActive: boolean;
	sx?: SxProps;
	onClick: () => void;
}) => (
	<ButtonBase
		onClick={onClick}
		sx={combineSX([
			{
				...CardLinkFrameSx,
				border: isActive ? '2px solid #774A91' : '1px solid #C9C9C9',
				backgroundColor: isActive ? '#F5F0FF' : '#fff',
				'& svg': {
					stroke: isActive ? '#774A91 !important' : '#2C2C2C',
					fill: isActive ? '#774A91 !important' : '#2C2C2C',
				},
				'& p': {
					color: isActive ? '#774A91' : '#2C2C2C',
				},
			},
			sx,
		])}
	>
		{icon}
		<Typography component="p" sx={CardLinkNameSx}>
			{name}
		</Typography>
	</ButtonBase>
);
